import React, { Component, Fragment } from "react";

// Checkbox list num painel dropdown (sem lib nova — não há nenhum padrão de
// multi-select já pronto no projeto). Controlado: `selecionados` (array de
// valores) e `onChange(novoArray)` vêm do pai; array vazio = "Todas" (sem
// filtro), mesmo significado que o antigo <select> single tinha pra "Todas".
export default class MultiSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { aberto: false };
    }

    alternarAberto = () => {
        this.setState((estadoAnterior) => ({ aberto: !estadoAnterior.aberto }));
    }

    alternarOpcao = (valor) => {
        let { selecionados, onChange } = this.props;
        let jaSelecionado = selecionados.includes(valor);
        let novoArray = jaSelecionado ? selecionados.filter((v) => v !== valor) : [...selecionados, valor];
        onChange(novoArray);
    }

    render() {
        let { label, opcoes, selecionados, idComponente } = this.props;
        let { aberto } = this.state;
        let rotuloBotao = selecionados.length === 0 ? "Todas" : `${selecionados.length} selecionada(s)`;

        return (
            <Fragment>
                <div className="form-group" style={{ position: "relative" }}>
                    <label>{label}: </label>
                    <button
                        type="button"
                        className="form-control text-left dropdown-toggle"
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        onClick={this.alternarAberto}
                        id={idComponente}
                    >
                        {rotuloBotao}
                    </button>

                    {aberto && (
                        <div
                            className="card"
                            style={{ position: "absolute", zIndex: 10, width: "100%", maxHeight: "220px", overflowY: "auto" }}
                        >
                            <div className="card-body p-2">
                                {opcoes.map((opcao) => (
                                    <div className="form-check" key={opcao.value}>
                                        <label className="form-check-label">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={selecionados.includes(opcao.value)}
                                                onChange={() => this.alternarOpcao(opcao.value)}
                                            />
                                            {opcao.label}
                                            <span className="form-check-sign"></span>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </Fragment>
        )
    }
}
